import React, { useCallback, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile } from '@pascal/pascal-core';
import { Decimal } from 'decimal.js';
import { kenoBetStore } from '../../../../store/kenoBetStore';
import useTranslation from '../../../../hooks/useTranslation';
import { TranslationKeys } from '../../../../core/constants/translationKeys';
import { BetStatus } from '../../../../core/constants/betStatus';
import { MAX_TICKETS_COUNT } from '../../../../core/constants/gameConstants';
import { BetResponseCodes, MaxTicketsCountCode } from '../../../../core/constants/betResponseCodes';
import { userInfoStore } from '../../../../store/userInfoStore';
import { ValidationType } from '../../../../core/constants/validationType';
import { useBalance } from '../../../../hooks/useBalance';
import { applicationStore } from '../../../../store/applicationStore';

const AddTicket = observer(() => {
  const [isShowTicketAnimation, setIsShowTicketAnimation] = useState(false);
  const { updateTickets, selectedNumbers, isBetsClosed, reBetModel, tickets, setNotification } =
    kenoBetStore;
  const { limits, betAmount, userBalance } = userInfoStore;
  const { demoBalance, isDemo } = applicationStore;

  const balance = useBalance(isDemo, demoBalance, userBalance);

  const t = useTranslation();

  const handleIsShowTicketAnimation = useCallback(() => {
    setIsShowTicketAnimation(true);
    setTimeout(() => {
      setIsShowTicketAnimation(false);
    }, 360);
  }, []);

  const handleAddTicket = useCallback(() => {
    const pendingTickets = tickets.filter((el) => el.status === BetStatus.Pending);
    const totalAmount = pendingTickets
      .reduce((acc, current) => {
        return acc.plus(current.amount);
      }, new Decimal(0))
      .valueOf();
    if (+betAmount + +totalAmount > balance) {
      setNotification(BetResponseCodes[ValidationType.NotEnoughMoney]);
    } else {
      if (pendingTickets.length + 1 > MAX_TICKETS_COUNT) {
        setNotification(MaxTicketsCountCode);
        return;
      }
      updateTickets();
      handleIsShowTicketAnimation();
    }
  }, [tickets, handleIsShowTicketAnimation, setNotification, updateTickets, balance, betAmount]);

  const isAddTicketButtonActive = useMemo(() => {
    return +betAmount <= limits?.maxBet && +betAmount >= limits?.minBet;
  }, [betAmount, limits]);

  if (reBetModel && isMobile()) {
    return null;
  }
  return (
    <div className='keno-tickets-add-btn-block'>
      <div
        className={`ticket-move-block move-add-ticket ${isShowTicketAnimation ? 'active' : ''}`}
      />
      <button
        type='button'
        className={`keno-tickets-add-btn ${
          selectedNumbers.length && !isBetsClosed && isAddTicketButtonActive ? '' : 'disabled'
        }`}
        onClick={handleAddTicket}
      >
        <span className='keno-tickets-txt'>{t(TranslationKeys.Add)}</span>
        <span className='btn-bg' />
      </button>
    </div>
  );
});
export default AddTicket;
